import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { PagesService } from '../../../services/pages.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'message-info-db',
  standalone: false,
  templateUrl: './create-message-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./create-message-info.component.scss']
})
export class MessageInfoComponent {
   content: string | null = null;
     constructor(
    private pagesService: PagesService,
    @Inject(MAT_DIALOG_DATA) public data: { pageId: number | string }
  ) {}

  ngOnInit(): void {
    this.pagesService.getPage(this.data.pageId).subscribe(page => {
      this.content = page.content;
    });
  }
}
